<template>
  <div id="Units">
    <v-row no-gutters>
      <v-col cols="12">
        <v-card>
          <v-card-title>
            <v-spacer/>
            <v-form lazy-validation ref="searchValidation">
              <v-text-field
                style="max-width: 250px"
                dense
                outlined
                hide-details
                clearable
                :placeholder="$t('general.search')"
                v-model="search"
                append-icon="search"
                class="mr-2"
                :rules="rules.textNoSpecialCharsFilters"
                @click:append="searching"
                @keyup.enter="searching"
              />
            </v-form>
            <v-btn color="primary" depressed to="units/add">{{$t('units.add')}}</v-btn>
            <v-btn class="ml-2" color="primary" depressed to="/units/add/multiple">{{$t('units.addMultiple')}}</v-btn>
          </v-card-title>
          <v-card-text>
            <v-overlay absolute opacity="0" :value="loadTable"/>
            <v-data-table
              :headers="headers"
              :items="units"
              :options.sync="options"
              :footer-props="{ 'items-per-page-options': [15, 25, 50, 75, 100] }"
              :server-items-length="options.total"
              :loading="loadTable"
              @update:page="get()"
              @update:items-per-page="get()"
              @update:sort-by="get()"
              @update:sort-desc="get()"
              >
              <template v-slot:item="props" >
                <tr>
                  <td align="left">{{props.item.unit_number}}</td>
                  <td align="left">{{props.item.vin_number}}</td>
                  <td align="left" v-if="props.item.plates && props.item.plates.length > 1">
                    <v-tooltip right>
                      <template v-slot:activator="{ on }">
                        <v-chip color="primary" v-on="on" small>{{props.item.plates[0].plate_number}}</v-chip>
                      </template>
                      <span>
                        <span class="font-weight-black">{{$t('general.plates')}}:</span>
                        <li v-for="plate in props.item.plates" :key="plate.id">
                          {{plate.plate_number}}
                        </li>
                      </span>
                    </v-tooltip>
                    &nbsp;(+{{props.item.plates.length - 1}})
                  </td>
                  <td align="left" v-else-if="props.item.plates && props.item.plates.length === 1">
                    <v-chip color="primary" small>{{props.item.plates[0].plate_number}}</v-chip>
                  </td>
                  <td align="left" v-else-if="props.item.plates && props.item.plates.length < 1">
                    {{$t('units.noPlates')}}
                  </td>
                  <td v-else>--</td>
                  <td align="left">{{props.item.brand ? props.item.brand : '--'}}</td>
                  <td align="left">{{props.item.model ? props.item.model : '--'}}</td>
                  <td align="left">{{props.item.unit_types.alias}}</td>
                  <td align="left">{{props.item.sites_name}}</td>
                  <td align="left">{{$t(`units.${props.item.owner}`)}}<p v-if="props.item.owner === 'EXTERNAL'">{{props.item.owner_name ? `(${props.item.owner_name})` : ''}}</p></td>
                  <td align="left">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon class="mr-4" small v-on="on" @click="edit(props.item.id)">far fa-edit</v-icon>
                      </template>
                      <span>{{$t('general.edit')}}</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon small v-on="on" @click="remove(props.item)">far fa-trash-alt</v-icon>
                      </template>
                      <span>{{$t('general.remove')}}</span>
                    </v-tooltip>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="dialog" width="500px">
      <v-card>
        <v-toolbar color="grey lighten-5" flat class="mb-5">
          <h3 class="error--text">{{$t('general.confirm')}}</h3>
        </v-toolbar>
        <v-card-text>
          <p>{{$t('units.delMessage')}}?</p>
          <p><span class="error--text font-weight-black">{{$t('general.name')}}:</span> {{removedItem.unit_types.alias}}</p>
          <p><span class="error--text font-weight-black">{{$t('general.site')}}:</span> {{removedItem.sites_name || 'N/A'}}</p>
          <p><span class="error--text font-weight-black">{{$t('general.plates')}}: </span>
            <v-chip class="font-weight-black" small v-for="plate in removedItem.plates" :key="plate.id">{{plate.plate_number}}</v-chip>
          </p>
        </v-card-text>
        <v-divider/>
        <v-card-actions>
          <v-spacer/>
          <v-btn color="error" text @click="close">{{$t('general.cancel')}}</v-btn>
          <v-btn color="error" depressed @click="confirmRemove">{{$t('general.accept')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'Units',
  data () {
    return {
      dialog: false,
      search: '',
      pageCount: 0,
      loading: false,
      loadTable: false,
      options: {
        page: 1,
        itemsPerPage: 15,
        total: 0
      },
      removedItem: {
        unit_types: {
          name: ''
        },
        sites: {
          name: ''
        },
        plates: []
      },
      defaultItem: {
        unit_types: {
          name: ''
        },
        sites: {
          name: ''
        },
        plates: []
      },
      units: [],
    }
  },
  created () {
    this.get()
  },
  computed: {
    headers () {
      return [
        {
          text: this.$t('general.unitNumber'),
          value: 'unit_number',
          align: 'left',
          sortable: true
        },
        {
          text: 'VIN',
          value: 'vin_number',
          align: 'left',
          sortable: true
        },
        {
          text: this.$t('general.plates'),
          value: 'plates',
          align: 'left',
          sortable: true
        },
        {
          text: this.$t('general.brand'),
          value: 'brand',
          align: 'left',
          sortable: true
        },
        {
          text: this.$t('general.model'),
          value: 'model',
          align: 'left',
          sortable: true
        },
        {
          text: this.$t('general.unitType'),
          value: 'unit_type_id',
          align: 'left',
          sortable: true
        },
        {
          text: this.$t('general.site'),
          value: 'sites',
          align: 'left',
          sortable: true
        },
        {
          text: this.$t('general.property'),
          value: 'owner',
          align: 'left',
          sortable: true
        },
        {
          text: this.$t('general.actions'),
          align: 'left',
          sortable: false
        }
      ]
    },
    rules () {
      return this.$validationRules()
    }
  },
  methods: {
    close () {
      this.dialog = false
      this.removedItem = Object.assign({}, this.defaultItem)
    },
    edit (id) {
      this.$router.push('units/edit/' + id)
    },
    remove (item) {
      this.removedItem = item
      this.dialog = true
    },
    confirmRemove () {
      this.$store.dispatch('units/delete', {event: {item: this.removedItem, context: this}})
    },
    searching () {
      if(this.search && !this.$refs.searchValidation.validate()) return this.showNotification(this.$t('validation.noSpecialChars'), 'warn', -1)
    
      this.$refs.searchValidation.resetValidation()

      if(this.options.page === 1) return this.get()

      this.options.page = 1
    },
    get () {
      if(this.loadTable ) return

      this.loadTable = true

      this.$store.dispatch('units/get', {
        event: {
          perPage: this.options.itemsPerPage,
          page: this.options.page,
          sortKey: (this.options.sortBy && this.options.sortBy.length > 0) ? this.options.sortBy[0] : 'id',
          ord: this.options.sortDesc && this.options.sortDesc[0] ? 'asc' : 'desc',
          find: this.search,
          context: this
        }
      })
    }
  }
}
</script>